import {createContext, m} from '@codeurs/front'
import {Component, ReactNode} from 'react'

type ToggleApi = {
	value: boolean
	toggle: () => void
	set: (value: boolean) => void
}

export const ToggleContext = createContext<ToggleApi>(undefined)

export class Toggle extends Component<{
	defaultValue?: boolean
	children: ((api: ToggleApi) => ReactNode) | ReactNode
}> {
	state = {
		value: !!this.props.defaultValue
	}

	render() {
		const {children} = this.props
		const api = {
			value: this.state.value,
			toggle: () => this.setState({value: !this.state.value}),
			set: value => this.setState({value})
		}

		return (
			<ToggleContext.Provider value={api}>
				{typeof children === 'function' ? (children as any)(api) : children}
			</ToggleContext.Provider>
		)
	}
}
